import { Component, ElementRef, EnvironmentInjector, OnInit, ViewChild, runInInjectionContext } from "@angular/core";
import { Observable, Observer, Subscription, timer } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
//import { Socket } from "ngx-socket-io";
import * as _ from "lodash";
import * as M from "materialize-css/dist/js/materialize";
import { LoginService } from "../../Services/login.service";
import { SharedService } from "../../Services/sharedService";
import { config } from "src/app/config";
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { ProjectService } from "src/app/Services/project.service";
import {
  AngularFireDatabase,
  AngularFireList,
} from "@angular/fire/compat/database";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatPaginator } from "@angular/material/paginator";
import { MessagingServiceService } from "src/app/Services/messaging-service.service";
import { TourConfigService } from "src/app/Services/tour-config.service";
import { MatDialog } from "@angular/material/dialog";
import { ImportUsersComponent } from "../import-users/import-users.component";
import moment from "moment";
import { ChangeDetectorRef } from "@angular/core";
import { Sort } from "@angular/material/sort";
import { CustomTimeAgoPipe } from "src/app/time-ago.pipe";
import { TimeConversionService } from 'src/app/Services/time-conversion.service'
import { InviteFocusDialogComponent } from "src/app/components/invite-focus-dialog/invite-focus-dialog.component";
import { UsersTableComponent } from "../users-table/users-table.component";
import { DummyDataService } from "src/app/Services/dummy-data.service";
import { Employee } from "src/app/interface/employee";
import { ModalService } from "src/app/Services/modal.service";
import { CreateUserComponent } from "../create-user/create-user.component";
import { DownloadModalComponent } from "../create-user/download-modal/download-modal.component";
import {
  CreateUserDialogData,
  CreateUserDialogResult,
  CreatedEmployeePayload,
  DownloadModalCloseResult,
  mapSendEmailToActorRoute,
  mapVersionTypeToActivationMode,
} from "../create-user/create-user-dialog.types";
import { ActivationEmployeeHandoffService } from "src/app/onboarding-checklist/activation-employee-handoff.service";
import { ActivationJourneyService } from "src/app/onboarding-checklist/activation-journey.service";
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import { TrialOnboardingHelpActionsService } from "src/app/Services/trial-onboarding-help-actions.service";
import { canManageCompanyEmployees } from "src/app/entitlements/plan-role.util";
import { take } from "rxjs/operators";
import {
  filterEmployeesBySelectedStatuses,
  getEmployeeListStatusType,
} from "src/app/utils/employee-status.util";
import {
  compareLastSeenOldestFirst,
  getLastSeenMs,
} from "src/app/utils/employees-list-presence.util";
import { PlanUpgradeDialogComponent } from "src/app/components/plan-upgrade-dialog/plan-upgrade-dialog.component";
import { trackClarityEvent } from "src/app/utils/clarity-event.util";

declare var $;

class User {
  id: string;
  email: string;
  ssRequest: boolean;
  scRequestStart: boolean;
  scRequestStop: boolean;
  status: string;
  time: string;
  isreceive: boolean;
}
@Component({
  selector: "app-user-list",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.css"],
  standalone: false
})
export class UserListComponent implements OnInit {

  @ViewChild("EmpPaginator", { static: true }) EmpPaginator: MatPaginator;
  activeSort: Sort; // Current sort state (column and direction)

  userDataSubscription1: Subscription;
  userDataSubscription2: Subscription;

  usersRef: AngularFireList<User> = null;
  searchText: string = "";
  dataSource = new MatTableDataSource<any>([]);
  TeamdataSource = new MatTableDataSource<any>([]);
  adminId;
  isViewMore = true;
  developerList;
  filteredList: any = [];
  loading = true;
  isRefreshing = false;
  iswordpress = false;
  isSearchActive = false; // Flag to track if search is currently active
  createUserForm: UntypedFormGroup;
  createTeamForm: UntypedFormGroup;
  /*Socket variables*/
  documents: Observable<string[]>;
  statusToUpdate: any;
  groupId: any;
  currentUser: any = {};

  filePath = config.baseMediaUrl;
  status: any;
  devList: any;
  private _docSub: Subscription;
  allUsers: any;
  empName;
  empSlug;
  teamStatus;
  teamSlug;
  teamTitle;
  employeeId;
  isTeamCreate;
  teamSelectedId;
  stopLoading: Boolean = false;
  isUserEditable: any;
  editUserId: any;
  page = 0;
  pageSize = 25; // Default page size
  totalUser;
  quota_remaining = 0;
  availableUser;
  roles: any = [
    "Admin",
    "Employee"
  ]
  daysRemaining: number;
  private dbPath: string | null = null;
  // Start as an empty array so filters that fire before the user fetch resolves
  // (common on fresh/trial signups with 0–1 employees) can safely call .slice()
  // instead of crashing with "Cannot read properties of undefined (reading 'slice')".
  allUserList: any[] = [];
  totalUsers = 0;
  isAdmin = false;
  canManageEmployees = false;
  isQuota = false;
  isTrialBanner = true;
  isExpiredBanner = true;
  quotaStatus = '';
  deleteUSer = false;
  expired: Boolean;
  openInvitedFocusDialogSub: any;
  setTimerFocusDialog: any;
  timerSubDialog: any;
  totalDuration: number = 600000;
  dialogRefForInviteModal: any;
  selectedStatusFilter: any = { label: 'All', value: 'all', class: "bg-[#326da8]" };
  selectedStatusFilters: string[] = [];
  /** Bumped when Firebase updates employee status in place — drives tab counts. */
  statusEpoch = 0;
  isFilterInitialized = false;
  queryFiltered: any;
  pageSizeOption = [25, 50, 100];
  disableNextFlag = false;
  totalStatusFilteredUsers: any = [];
  searchedValue: string = "";
  /** Holds the initial search value restored from URL for pre-filling the search input. */
  initialSearchValue: string = '';

  @ViewChild('userModal') modalRef: ElementRef<HTMLInputElement>;
  @ViewChild(UsersTableComponent) usersTableComp!: UsersTableComponent;
  isOpenCreateNewUserModal: boolean = false;
  closeModalSub: any;

  constructor(
    private _loginService: LoginService,
    private _projectService: ProjectService,
    private _modalService: ModalService,
    private route: ActivatedRoute,
    private _router: Router,
    private _sharedService: SharedService,
    private db: AngularFireDatabase,
    private _messagingService: MessagingServiceService,
    private _tourService: TourConfigService,
    private dialog: MatDialog,
    private _cd: ChangeDetectorRef,
    private _dummyDataService: DummyDataService,
    private tokenEncryptionService: TokenEncryptionService,
    private injector: EnvironmentInjector,
    private _trialOnboardingHelpActions: TrialOnboardingHelpActionsService,
    private employeeHandoff: ActivationEmployeeHandoffService,
    private activationJourney: ActivationJourneyService
  ) {
    // Initialize pageSize from localStorage
    const savedPageSize = localStorage.getItem('pageSize');
    if (savedPageSize && [25, 50, 100].includes(Number(savedPageSize))) {
      this.pageSize = Number(savedPageSize);
    }
    if (sessionStorage.getItem('isTrialBanner')) {
      this.isTrialBanner = true;
      this.isExpiredBanner = true;
    }

    // Listen for dbPath updates
    this._projectService.isFirebaseRefresh.subscribe((newDbPath: any) => {
      if (newDbPath && newDbPath.data) {
        this.dbPath = newDbPath.data;
        console.log('UserList: dbPath updated to:', this.dbPath);
        // Re-initialize Firebase reference if needed
        if (this.usersRef) {
          this.usersRef = runInInjectionContext(this.injector, () => this.db.list(this.dbPath));
        }
      }
    });

    _messagingService.showNotification();
    this.dbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;
    this.currentUser = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser') || {};
    this.getQuota();
    this.getUSer();
    this._projectService.EmployeeList.subscribe((value) => {
      // console.log("value", value);
      this.page = this.EmpPaginator["_pageIndex"] + 1;
      this.getQuota();
      this.getAllUserList(true).then(() => {
        this.updateDevList();
      })
      // this.getDevList();
      this.getUSer();
    });
    this._projectService.dashboardTourActive.subscribe((value: any) => {

      this.getQuota();
      // Only update dev list if search is not active
      if (!this.isSearchActive) {
        this.updateDevList();
      }
      this.getUSer();
    })

    // Only initialize Firebase reference if dbPath exists
    if (this.dbPath) {
      this.usersRef = this.db.list(this.dbPath);
    } else {
      console.warn('UserList: dbPath not set, Firebase reference not initialized');
    }

    this.createUserForm = new UntypedFormGroup({
      userName: new UntypedFormControl("", [Validators.required]),
      userEmail: new UntypedFormControl("", [Validators.required]),
      password: new UntypedFormControl("", [Validators.required]),
      confirmPass: new UntypedFormControl("", [Validators.required]),
      roleList: new UntypedFormControl(this.roles, [Validators.required]),
    });

    this.createTeamForm = new UntypedFormGroup({
      status: new UntypedFormControl(""),
      title: new UntypedFormControl(""),
      slug: new UntypedFormControl(""),
      team_manager: new UntypedFormControl(""),
      team_lead: new UntypedFormControl(""),
      team_developer: new UntypedFormControl(""),
    });
    // this.socket.removeAllListeners();
    $(document).ready(function () {
      $(".fixed-action-btn").floatingActionButton();
      $(".tooltipped").tooltip();
    });

    //this.socket.emit("getStatus", { doc: "" });
    this.route.params.subscribe((user) => {
      this.groupId = user.groupId;
    });

    this.route.queryParams.subscribe((params) => {
      if (params && params.status) {
        this.status = params.status;
      }
    });
  }

  async ngOnInit() {
    this.loading = true;

    // Restore page from URL query param if present
    const urlPage = this.route.snapshot.queryParams['page'];
    if (urlPage && !isNaN(Number(urlPage))) {
      this.page = Number(urlPage);
      // Sync the paginator to the restored page (0-indexed)
      if (this.EmpPaginator) {
        this.EmpPaginator.pageIndex = this.page - 1;
      }
    } else {
      this.page = this.EmpPaginator["_pageIndex"] + 1;
    }

    // Read initial search value from URL for template binding
    this.initialSearchValue = this.route.snapshot.queryParams['search-employee'] || '';

    this.route.queryParams.subscribe((params) => {
      if (params && params['edit-employee']) {
        // Use setTimeout to ensure the modal DOM is ready and users are loaded, and navigation is complete

        if (this._modalService.isAlreadyOpenDialog(CreateUserComponent)) {
          this._modalService.closeDialogIfOpen(CreateUserComponent);
        }
        const dialogRef = this._modalService.openCommonMatDialog(
          CreateUserComponent,
          {
            className: 'create-user-modal',
            maxHeight: '80vh',
            disableClose: false,
            componentData: { isUserEditable: true, editUserId: params['edit-employee'] },
          }
        );

        dialogRef.afterClosed().subscribe(() => {
          void this._router.navigate([], {
            relativeTo: this.route,
            queryParams: { 'edit-employee': null },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        });

      }
    });

    // Check if we need to suppress initial invite modal and clear the query param after some time
    // Do NOT use this path during activation handoff — it strips handoff context after 3s.
    const suppressInviteModal = this.route.snapshot.queryParams['suppressInviteModal'];
    if (suppressInviteModal === 'true' && !this.employeeHandoff.isActive()) {
      // Clear the query parameter after 3 seconds to allow normal behavior in the future
      setTimeout(() => {
        this._router.navigate(['/employees'], { replaceUrl: true });

        // Check if we need to trigger invite modal after suppression is cleared
        const triggerAfterSuppression = localStorage.getItem('triggerInviteModalAfterSuppression');
        if (triggerAfterSuppression === 'true') {
          localStorage.removeItem('triggerInviteModalAfterSuppression');
          // Trigger invite modal after a short delay
          setTimeout(() => {
            this._sharedService.setTimerFocusDialog.next(true);
          }, 1000);
        }
      }, 3000);
    }

    this.getAllUserList(true).then(() => {
      this.updateDevList();

      // Restore search from URL query param if present
      const urlSearch = this.route.snapshot.queryParams['search-employee'];
      if (urlSearch) {
        this.searchEmployee(urlSearch);
      }

      // Re-apply filter after data is loaded to ensure proper filtering
      this.reapplyCurrentFilter();
    });

    // Reload mid-handoff after create: return to journey connection screen, do not reopen create.
    const handoffSession = this.employeeHandoff.getSession();
    if (handoffSession?.phase === 'created' && handoffSession.employeeId) {
      void this._router.navigate(['/setup/first-employee'], { replaceUrl: true });
      this.employeeHandoff.finishReturn();
      return;
    }

    // Handle create-employee / activation handoff param
    const createParam = this.route.snapshot.queryParams['create-employee'];
    const activationHandoffParam = this.route.snapshot.queryParams['activationHandoff'];
    if (createParam !== undefined || activationHandoffParam === 'first_employee') {
      this.openUserCreateModal();
    }

    // Handle edit-employee param
    const editParam = this.route.snapshot.queryParams['edit-employee'];
    if (editParam) {
      if (this._modalService.isAlreadyOpenDialog(CreateUserComponent)) {
        this._modalService.closeDialogIfOpen(CreateUserComponent);
      }
      const dialogRef = this._modalService.openCommonMatDialog(
        CreateUserComponent,
        {
          className: 'create-user-modal',
          maxHeight: '80vh',
          disableClose: false,
          componentData: { isUserEditable: true, editUserId: editParam },
        }
      );

      // Remove param when dialog closes
      if (dialogRef && dialogRef.afterClosed) {
        dialogRef.afterClosed().subscribe(() => {
          this._router.navigate([], {
            relativeTo: this.route,
            queryParams: { 'edit-employee': null },
            queryParamsHandling: 'merge'
          });
        });
      }
    }

    // Handle import-employees param
    const importParam = this.route.snapshot.queryParams['import-employees'];
    if (importParam !== undefined) {
      // Import modal requires ElementRef – cleared immediately, user can open via button
      this._router.navigate([], {
        relativeTo: this.route,
        queryParams: { 'import-employees': null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }

    this.setSubjects();
  }

  ngAfterViewInit() {
    this._cd.detectChanges();
    M.AutoInit();
    this.route.queryParams.subscribe((params) => {
      if (params.openCreateUser == "true") {
        // Prefer create-employee; avoid opening a second dialog.
        if (this._modalService.isAlreadyOpenDialog(CreateUserComponent)) {
          return;
        }
        this.openUserCreateModal();
      }
    });
  }

  ngAfterContentInit(): void {
  }

  ngOnDestroy() {
    if (this.userDataSubscription1) {
      this.userDataSubscription1.unsubscribe();
    }
    if (this.userDataSubscription2) {
      this.userDataSubscription2.unsubscribe();
    }

    if (this.setTimerFocusDialog) {
      this.setTimerFocusDialog.unsubscribe();
    }

    if (this.openInvitedFocusDialogSub) {
      this.openInvitedFocusDialogSub.unsubscribe();
    }

    if (this.closeModalSub) {
      this.closeModalSub.unsubscribe();
    }
    // Do not resetData() — tearing down the global screenshot ack listener breaks
    // Live Monitoring toasts/audit after leaving Employees (SUSEE-1574).
  }

  getAllUserList(forceRefresh: boolean = false) {
    this.loading = true;
    return new Promise((resolve, reject) => {
      this._projectService.getUserList(0, 0, forceRefresh).subscribe(
        async (data: any) => {
          const employeesOnly = Array.isArray(data) ? data.filter((user: any) => this.isEmployeeUser(user)) : [];
          this.allUserList = employeesOnly;
          this.totalUsers = employeesOnly.length;
          let teamsData = await this.getTeamsData();
          this.allUserList = await this._sharedService.assignTeamsAccordingList(employeesOnly, teamsData);
          // Apply sorting if active
          if (this.activeSort && this.activeSort.active && this.activeSort.direction) {
            this.applySorting();
          }
          this.loading = false;
          resolve(true);
        },
        (error) => {
          console.error("Error fetching all users:", error);
          this.loading = false;
          reject(error);
        }
      );
    });
  }


  isTourActive() {
    if (localStorage.getItem('isTour')) {
      if (localStorage.getItem('isTour') == 'false') {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  IncreaseLimitAction() {
    window.open('Https://supersee.io', '_blank')
  }
  quataUpdate() {
    if (this.isQuota) {
      return true;
    } else {
      return false;
    }
  }
  getQuota() {
    if (this.isTourActive()) {
      this
        ._projectService
        .getQuota().subscribe((user: any) => {
          if (user.quota == false || user.quota == 'false') {
            this.isQuota = true;
          } else {
            this.isQuota = false;
          }
        }, err => { })
    }
  }

  openPlanUpgradeModal(): void {
    trackClarityEvent('quota_upgrade_clicked_from_employee_list');
    const ref = this.dialog.open(PlanUpgradeDialogComponent, {
      width: '420px',
      maxWidth: '94vw',
      data: {
        title: 'User Limit Reached',
        message: 'You have no remaining employee seats. Upgrade your plan to add more employees.',
        confirmLabel: 'Upgrade plan',
      },
    });
    ref.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        void this._router.navigate(['/billings'], { queryParams: { intent: 'upgrade' } });
      }
    });
  }

  /** True when the company still has seats to invite/add employees. */
  get hasRemainingEmployeeQuota(): boolean {
    const q = this.quota_remaining as any;
    if (q === false || q === 'false' || q == null || q === '') {
      return false;
    }
    const n = Number(q);
    return !Number.isNaN(n) && n > 0;
  }

  openUserCreateModal() {
    if (this._modalService.isAlreadyOpenDialog(CreateUserComponent)) {
      return;
    }
    if (this._modalService.isAlreadyOpenDialog(DownloadModalComponent)) {
      return;
    }

    this.isUserEditable = false;
    this.editUserId = null;

    const activationHandoffActive =
      this.employeeHandoff.isActive() ||
      this.route.snapshot.queryParams['activationHandoff'] === 'first_employee';

    if (activationHandoffActive && !this.employeeHandoff.isActive()) {
      this.employeeHandoff.begin();
    }

    // Persist create-employee in URL (keep activationHandoff when present)
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        'create-employee': 'true',
        ...(activationHandoffActive ? { activationHandoff: 'first_employee' } : {}),
      },
      queryParamsHandling: 'merge'
    });

    const componentData: CreateUserDialogData = {
      isUserEditable: this.isUserEditable,
      editUserId: this.editUserId,
      ...(activationHandoffActive
        ? {
            activationHandoff: {
              source: 'activation_journey' as const,
              returnRoute: '/setup/first-employee' as const,
            },
          }
        : {}),
    };

    const dialogRef = this._modalService.openCommonMatDialog(
      CreateUserComponent,
      {
        className: 'create-user-modal',
        maxHeight: '80vh',
        disableClose: false,
        componentData,
      }
    );

    if (dialogRef && dialogRef.afterClosed) {
      dialogRef.afterClosed().pipe(take(1)).subscribe((result: CreateUserDialogResult | undefined) => {
        this.clearCreateEmployeeQueryParams();

        if (!result) {
          if (activationHandoffActive) {
            this.employeeHandoff.returnToSetup(true);
          }
          return;
        }

        if (result.reason === 'cancel') {
          if (activationHandoffActive) {
            this.employeeHandoff.returnToSetup(true);
          }
          return;
        }

        if (result.reason === 'edit_success') {
          this._projectService.updateEmployeeList({});
          return;
        }

        if (result.reason === 'create_success') {
          this.handleEmployeeCreated(result.employee, activationHandoffActive);
        }
      });
    }
  }

  private clearCreateEmployeeQueryParams(): void {
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: { 'create-employee': null, activationHandoff: null },
      queryParamsHandling: 'merge'
    });
  }

  private handleEmployeeCreated(
    employee: CreatedEmployeePayload,
    activationHandoffActive: boolean
  ): void {
    this._projectService.updateEmployeeList({});

    if (activationHandoffActive) {
      this.activationJourney.setFirstEmployeeMeta({
        employeeId: employee.employeeId,
        mode: mapVersionTypeToActivationMode(employee.versionType),
        actorRoute: mapSendEmailToActorRoute(employee.sendEmail),
      });
      this.activationJourney.setStatusPhase('package_prepared');
      this.employeeHandoff.recordCreated({
        employeeId: employee.employeeId,
        versionType: employee.versionType,
        operatingSystem: employee.operatingSystem,
      });
      this.activationJourney.flushServerSync().subscribe();
    }

    this.openDownloadModalForEmployee(employee, activationHandoffActive);
  }

  private openDownloadModalForEmployee(
    employee: CreatedEmployeePayload,
    activationHandoffActive: boolean
  ): void {
    if (this._modalService.isAlreadyOpenDialog(DownloadModalComponent)) {
      this._modalService.closeDialogIfOpen(DownloadModalComponent);
    }

    const modalRef = this._modalService.openCommonMatDialog(DownloadModalComponent, {
      className: 'download-modal',
      disableClose: true,
      maxHeight: '90vh',
      componentData: {
        message: 'Employee created successfully!',
        versionType: employee.versionType,
        operatingSystem: employee.operatingSystem,
        email: employee.email,
        password: employee.installerPassword,
        name: employee.name,
        first_name: employee.firstName,
        last_name: employee.lastName,
        ...(activationHandoffActive
          ? {
              activationHandoff: {
                source: 'activation_journey' as const,
                returnRoute: '/setup/first-employee' as const,
              },
            }
          : {}),
      },
    });

    if (!modalRef?.afterClosed) {
      return;
    }

    modalRef.afterClosed().pipe(take(1)).subscribe((closeResult: DownloadModalCloseResult | undefined) => {
      this._projectService.updateEmployeeList({});

      if (activationHandoffActive) {
        if (closeResult?.downloadTriggered) {
          this.activationJourney.trackEvent('installer_downloaded', {
            employeeId: employee.employeeId,
            versionType: employee.versionType,
            operatingSystem: employee.operatingSystem,
          });
        }
        this.employeeHandoff.finishReturn();
        void this._router.navigate(['/setup/first-employee'], { replaceUrl: true });
        return;
      }

      // Normal Employees behavior
      this._sharedService.setTimerFocusDialog.next(true);
    });
  }

  openImportUserModal(elem: ElementRef) {
    // Persist import-employees in URL
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: { 'import-employees': 'true' },
      queryParamsHandling: 'merge'
    });

    if (this._sharedService.modalinstance) {
      this._sharedService.modalinstance = undefined;
    }
    this._sharedService.modalinstance = M.Modal.init(
      elem,
      {
        complete: () => {
          // Remove param when modal closes
          this._router.navigate([], {
            relativeTo: this.route,
            queryParams: { 'import-employees': null },
            queryParamsHandling: 'merge'
          });
        },
      },
      100
    );

    this._sharedService.modalinstance.open({
      oncancel: () => {
      },
    });

    // const importDialog = this.dialog.open(ImportUsersComponent, {
    //   width: '660px'
    // })
  }

  deleteEmployee() {
    this.developerList = [];
    this.filteredList = this.developerList;
    this.pageSize = this.EmpPaginator["_pageSize"];
    this.page = this.EmpPaginator["_pageIndex"] + 1;
    this.deleteUSer = true;
    // this.getDevList();
    this.getAllUserList(true).then(() => {
      this.updateDevList();
    });
    this.getQuota();
    this.getUSer();

    // Show success message and ensure we're on the employees page
    this._sharedService.showToast({
      type: 'Employee Deleted Successfully',
      message: 'The employee has been removed from the system.'
    });
  }

  getAll(): AngularFireList<User> {
    return this.usersRef;
  }

  filterUsers(event) {
    this.developerList = this.allUsers.filter((item) =>
      item.name.toLowerCase().includes(event.toLowerCase())
    );
    this.filteredList = this.developerList;

  }

  getDevList() {
    console.log("Get Dev List calls")
    this.stopLoading = true;
    if (this.isTourActive()) {
      this._projectService
        .getUserList(this.page, this.pageSize || 25)
        .subscribe(async (user: any) => {
          const employeesOnly = Array.isArray(user) ? user.filter((singleUser: any) => this.isEmployeeUser(singleUser)) : [];
          this.developerList = [];
          this.developerList = employeesOnly;
          this._projectService.updateEmployeeListData({ data: true })
          this.filteredList = this.developerList;
          this.allUsers = employeesOnly;
          const storedDbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;
          if (storedDbPath) {
            this.userDataSubscription2 = this._messagingService.getUserData().subscribe((users) => {
              users.forEach((o) => {
                if (this.developerList) {

                  let index = _.findIndex(this.developerList, function (obj: any) {
                    return obj.id == o.id;
                  });

                  if (index > -1) {
                    const isLogoutReason = this.checkLogoutReason(o.logoutReason?.time, o.lastOnlineAtTz);
                    if (o.lastOnlineAtTz != null) {
                      this.developerList[index]["lastOnlineAtTz"] = o.lastOnlineAtTz;
                    }
                    if (o.lastOnlineAt != null) {
                      this.developerList[index]["lastOnlineAt"] = o.lastOnlineAt;
                    }
                    if (o.logoutReason && isLogoutReason) {
                      this.developerList[index]["status"] = 'auto-logout';
                      if (o.logoutReason?.reason == 'timeOrTimezoneChange') {
                        this.developerList[index]["logoutReason"] = { 'reason': 'Time or Timezone Changed.', 'time': moment.utc(o.logoutReason?.time).local().format("YYYY-MM-DD HH:mm:ss") };
                      }
                    } else if (o.lastOnlineAtTz) {
                      this.developerList[index]["status"] = this._sharedService.getUserCurrentStatus(o.lastOnlineAtTz, true);
                    } else if (!o.lastOnlineAtTz && o.lastOnlineAt) {
                      this.developerList[index]["status"] = this._sharedService.getUserCurrentStatus(o.lastOnlineAt, false);
                    } else {
                      this.developerList[index]["status"] = 'not-using';
                    }

                    // for application information about version and application type.
                    if (o.appInfo) {
                      if (o.appInfo.applicationType && o.appInfo.version) {
                        o.appInfo.label = o.appInfo.applicationType.split("")[0].toUpperCase();
                        o.appInfo.applicationType = o.appInfo.applicationType[0].toUpperCase() + o.appInfo.applicationType.slice(1);
                        this.developerList[index]["appInfo"] = o.appInfo;
                      }
                    } else {
                      if (this.developerList[index]["status"] != "not-using") {
                        this.developerList[index]["appInfo"] = { version: "4.1.2" }
                      } else {
                        this.developerList[index]["appInfo"] = "";
                      }
                    }

                    // this.developerList[index]["time"] = o.time;
                    if (
                      o.ssRequest != true &&
                      o.ssRequest != false &&
                      o.ssRequest != undefined &&
                      o.ssRequest != null
                    ) {
                      this.developerList[index]["ssRequest"] =
                        o.ssRequest["createdAt"];
                    }
                    this.filteredList = this.developerList;
                  }
                }
              });
              console.log("Checking is this is comes from here", users)
              this.stopLoading = false;
              this.loading = false;
            });
          }
        });
    } else {
      this.developerList = [];
      // this.stopLoading = false;
      // this.loading = false;
    }
  }

  private isEmployeeUser(user: any): boolean {
    const roles = Array.isArray(user?.role) ? user.role : [];
    return roles.some((role: any) => String(role).toLowerCase() === 'employee');
  }

  getIsDemoData() {
    return localStorage.getItem(this._trialOnboardingHelpActions.demoDashboardOptInKey) === 'true';
  }

  async updateDevList() {
    const realEmpty = !this.allUserList || this.allUserList.length === 0;
    if (realEmpty && (await this._dummyDataService.shouldUseLegacySampleFallback(true))) {
      const dummyDataRes = await this._dummyDataService.checkIsAvailableDemoData<Employee[]>('EmployeeList');
      this.developerList = dummyDataRes.data || [];
      if (this.developerList?.length > 0) {
        this.developerList = this.enrichDummyUsers(this.developerList);
      }
      return;
    }

    if (!this.isTourActive()) {
      // Guided tour path only — never used for real account lists.
      this.stopLoading = false;
      this.developerList = this._dummyDataService.getDataByParams<Employee[]>('EmployeeList').data || [];
      if (this.developerList?.length) {
        this.developerList = this.enrichDummyUsers(this.developerList);
      }
      return;
    }

    // Apply sorting if active
    if (this.activeSort && this.activeSort.active && this.activeSort.direction) {
      this.applySorting();
    }

    // Only paginate if search is not active (to preserve search results)
    if (!this.isSearchActive) {
      this.paginateDevelopers();
    }

    const dbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;
    if (!dbPath) return;

    // The subscription to _messagingService.getUserData() updates allUserList in place.
    // So, after those updates, we need to re-sort and re-paginate.
    if (this.userDataSubscription2) {
      this.userDataSubscription2.unsubscribe(); // Unsubscribe from previous if any
    }

    this.userDataSubscription2 = this._messagingService.getUserData().subscribe((users) => {
      if (!this.allUserList || !this.allUserList.length) {
        return;
      }

      let changed = false;
      const updatedUserIds = new Set<string>();

      // Process all updates first before re-sorting
      users.forEach((user) => {
        const index = _.findIndex(this.allUserList, (u: any) => u.id === user.id);
        if (index < 0) return;

        // Update the user data in place
        this.updateUserStatus(index, user);
        this.updateUserSsRequest(index, user);
        this.updateUserAppInfo(index, user);

        this.updateUserAgentIntegrity(index, user);

        

        changed = true;
        updatedUserIds.add(user.id);
      });

      // If data changed and we have an active sort, re-sort and re-paginate
      if (changed && this.activeSort && this.activeSort.active && this.activeSort.direction) {
        // Check if any updated field affects the current sort
        const sortField = this.activeSort.active;
        const affectsSort = Array.from(updatedUserIds).some(id => {
          const user = this.allUserList.find(u => u.id === id);
          if (!user) return false;

          // Check if the updated field is the one we're sorting by
          switch (sortField) {
            case "screenshot":
              return true; // Screenshot updates always affect sort
            case "status":
              return true; // Status updates always affect sort
            case "health":
              return true; // Health updates affect sort
            case "usedApps":
              return true; // App changes affect sort
            case "appInfo":
              return true; // App info changes affect sort
            default:
              return false; // Name and role don't change from snapshots
          }
        });

        if (affectsSort) {
          // Re-sort the entire list
          this.applySorting();
          // Re-paginate with fresh slice to avoid duplicates
          if (!this.isSearchActive) {
            this.paginateDevelopers();
          }
        } else {
          // Sort field didn't change, just update visible users in place
          if (!this.isSearchActive && this.developerList) {
            this.updateVisibleListInPlace(Array.from(updatedUserIds).map(id =>
              this.allUserList.find(u => u.id === id)
            ).filter(Boolean));
          }
        }
      } else if (changed) {
        // Data changed but no sort - just update visible list
        if (!this.isSearchActive && this.developerList) {
          this.updateVisibleListInPlace(Array.from(updatedUserIds).map(id =>
            this.allUserList.find(u => u.id === id)
          ).filter(Boolean));
        }
      }
      if (changed) {
        this.statusEpoch++;
      }

      this._sharedService.triggerInviteFocusModalOpen.next(true);
      // No need to set loading = false here as it's handled by getAllUserList

      if (this.allUserList && this.selectedStatusFilters) {
        this.filterDataOnMultipleStatusChange(this.selectedStatusFilters);
        if (this.activeSort) {
          this.applySorting();
        }
      }
    });

    this.ensureAppInfoExists(); // This might not be necessary if appInfo is handled well in updates
    // but keeping it for now to match existing logic.
  }

  private paginateDevelopers(): void {
    if (!this.allUserList || !this.allUserList.length) {
      this.developerList = [];
      this.filteredList = [];
      return;
    }

    // Create a fresh slice to avoid duplicates
    const startIndex = (this.page - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    const newList = this.allUserList.slice(startIndex, endIndex);

    // Remove duplicates by ID (safety check)
    const uniqueMap = new Map<string, any>();
    newList.forEach(user => {
      if (user && user.id && !uniqueMap.has(user.id)) {
        uniqueMap.set(user.id, user);
      }
    });

    // Convert back to array, preserving order
    const uniqueList = Array.from(uniqueMap.values());

    // Only update if the list actually changed (different IDs or order)
    const currentIds = this.developerList?.map(u => u?.id).join(',') || '';
    const newIds = uniqueList.map(u => u?.id).join(',');

    if (currentIds !== newIds) {
      // List changed, assign new array
      this.developerList = uniqueList;
      this.filteredList = this.developerList;
    } else {
      // Same users in same order, just update properties in place
      uniqueList.forEach((newUser, idx) => {
        if (this.developerList[idx] && this.developerList[idx].id === newUser.id) {
          Object.assign(this.developerList[idx], newUser);
        }
      });
    }
  }

  private updateVisibleListInPlace(updatedUsers: any[]): void {
    // Update users in the visible list without re-sorting/re-paginating
    // This preserves row positions when data updates don't affect sort order
    updatedUsers.forEach((user) => {
      const visibleIndex = this.developerList.findIndex((u: any) => u.id === user.id);
      if (visibleIndex >= 0) {
        const allUserIndex = _.findIndex(this.allUserList, (u: any) => u.id === user.id);
        if (allUserIndex >= 0) {
          // Update the visible list item with data from allUserList (which was already updated)
          // This preserves the object reference to minimize re-renders
          const existingUser = this.developerList[visibleIndex];
          const updatedUser = this.allUserList[allUserIndex];

          // Only update changed properties to preserve object reference
          if (existingUser.status !== updatedUser.status) {
            existingUser.status = updatedUser.status;
          }
          if (JSON.stringify(existingUser.appInfo) !== JSON.stringify(updatedUser.appInfo)) {
            existingUser.appInfo = updatedUser.appInfo;
          }
          if (JSON.stringify(existingUser.osInfo) !== JSON.stringify(updatedUser.osInfo)) {
            existingUser.osInfo = updatedUser.osInfo;
          }
          if (existingUser.ssRequest !== updatedUser.ssRequest) {
            existingUser.ssRequest = updatedUser.ssRequest;
          }
          if (existingUser.meta?.last_screenshot !== updatedUser.meta?.last_screenshot) {
            if (!existingUser.meta) existingUser.meta = {};
            existingUser.meta.last_screenshot = updatedUser.meta?.last_screenshot;
          }
          if (existingUser.meta?.last_application_name !== updatedUser.meta?.last_application_name) {
            if (!existingUser.meta) existingUser.meta = {};
            existingUser.meta.last_application_name = updatedUser.meta?.last_application_name;
          }
          if (existingUser.idleStartTime !== updatedUser.idleStartTime) {
            existingUser.idleStartTime = updatedUser.idleStartTime;
          }
          if (existingUser.lastOnlineAtTz !== updatedUser.lastOnlineAtTz) {
            existingUser.lastOnlineAtTz = updatedUser.lastOnlineAtTz;
          }
          if (existingUser.lastOnlineAt !== updatedUser.lastOnlineAt) {
            existingUser.lastOnlineAt = updatedUser.lastOnlineAt;
          }
          if (JSON.stringify(existingUser.agentIntegrity) !== JSON.stringify(updatedUser.agentIntegrity)) {
            existingUser.agentIntegrity = updatedUser.agentIntegrity;
          }
        }
      }
    });
    this.filteredList = this.developerList;
  }


  private updateUserStatus(index: number, user: any): void {
    const isLogoutReason = this.checkLogoutReason(user.logoutReason?.time, user.lastOnlineAtTz);
    if (user.lastOnlineAtTz != null) {
      this.allUserList[index]["lastOnlineAtTz"] = user.lastOnlineAtTz;
    }
    if (user.lastOnlineAt != null) {
      this.allUserList[index]["lastOnlineAt"] = user.lastOnlineAt;
    }
    if (user.logoutReason && isLogoutReason) {
      this.allUserList[index]["status"] = 'auto-logout';
      if (user.logoutReason?.reason === 'timeOrTimezoneChange') {
        this.allUserList[index]["logoutReason"] = {
          reason: 'Time or Timezone Changed.',
          time: moment.utc(user.logoutReason?.time).local().format("YYYY-MM-DD HH:mm:ss")
        };
      }

    } else if (user.isIdle === true) {
      // Check for idle status from Firebase
      if (this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true) == 'online') {
        this.allUserList[index]["status"] = 'idle';
        // Store idleStartTime if available
        if (user.idleStartTime) {
          this.allUserList[index]["idleStartTime"] = user.idleStartTime;
        }
      } else if (this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true) != 'online') {
        this.allUserList[index]["status"] = this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true);
      }

    } else if (user.lastOnlineAtTz) {
      this.allUserList[index]["status"] = this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true);
    } else if (user.lastOnlineAt) {
      this.allUserList[index]["status"] = this._sharedService.getUserCurrentStatus(user.lastOnlineAt, false);
    } else {
      this.allUserList[index]["status"] = 'not-using';
    }
  }

  private updateUserAppInfo(index: number, user: any): void {

    const status = this.allUserList[index]["status"];

    if (user.appInfo?.applicationType && user.appInfo?.version) {
      const appType = user.appInfo.applicationType;
      user.appInfo.label = appType[0].toUpperCase();
      user.appInfo.applicationType = appType[0].toUpperCase() + appType.slice(1);
      this.allUserList[index]["appInfo"] = user.appInfo;
    } else {
      this.allUserList[index]["appInfo"] = status !== "not-using" ? { version: "4.1.2" } : "";
    }

    if (user.osInfo?.os && user.osInfo.os) {
      this.allUserList[index]["osInfo"] = user.osInfo;
    } else {
      this.allUserList[index]["osInfo"] = status !== "not-using" ? { os: "N/A", release: "N/A", version: "N/A" } : "";
    }
  }

  private updateUserAgentIntegrity(index: number, user: any): void {
    if (user.agentIntegrity) {
      this.allUserList[index]["agentIntegrity"] = user.agentIntegrity;
    }
    this.allUserList[index]["uninstall"] = user.uninstall ?? null;
  }

  private updateUserSsRequest(index: number, user: any): void {
    const ssRequest = user.ssRequest;
    if (ssRequest !== true && ssRequest !== false && ssRequest !== undefined && ssRequest !== null) {
      this.allUserList[index]["ssRequest"] = ssRequest["createdAt"];
    }
  }

  private ensureAppInfoExists(): void {
    this.developerList.forEach((developer: any) => {
      if (!developer.appInfo) {
        developer.appInfo = "";
      }

      if (!developer.osInfo) {
        developer.osInfo = "N/A";
      }
    });
  }

  private enrichDummyUsers(users: any[]): any[] {
    const applications = [
      'Google Chrome',
      'Visual Studio Code',
      'Discord',
      'Windows Explorer',
      'Slack',
      'Figma',
      'Outlook',
      'Microsoft Teams',
      'Edge',
      'Terminal'
    ];

    const shuffledApps = [...applications].sort(() => Math.random() - 0.5);
    const osPool = [
      { applicationType: 'Windows', label: 'W' },
      { applicationType: 'Mac', label: 'M' },
      { applicationType: 'Linux', label: 'L' },
    ];

    const usedMinuteOffsets = new Set<number>();
    const getUniqueMinutesAgo = (): number => {
      let minutes = 0;
      let tries = 0;
      // 5 minutes to 2 hours (120 minutes)
      do {
        minutes = 5 + Math.floor(Math.random() * (120 - 5 + 1));
        tries++;
      } while (usedMinuteOffsets.has(minutes) && tries < 50);
      usedMinuteOffsets.add(minutes);
      return minutes;
    };

    return users.map((user: any, index: number) => {
      const minutesAgo = getUniqueMinutesAgo();
      const lastScreenshot = new Date(Date.now() - minutesAgo * 60 * 1000).toISOString();
      const appName = shuffledApps[index % shuffledApps.length];
      const os = osPool[index % osPool.length];
      const version = `4.${1 + Math.floor(Math.random() * 5)}.${Math.floor(Math.random() * 10)}`;

      const enrichedMeta = {
        ...(user.meta || {}),
        last_screenshot: user.meta?.last_screenshot || lastScreenshot,
        last_application_name: user.meta?.last_application_name || appName,
      };

      const appInfo = user.appInfo || {
        version,
        applicationType: os.applicationType,
        label: os.label,
      };

      return { ...user, status: 'online', meta: enrichedMeta, appInfo };
    });
  }

  sortData(sort: Sort) {
    this.activeSort = sort; // Store the current sort state

    if (!this.developerList || !this.developerList.length) {
      return;
    }

    this.applySorting();

    if (sort.direction == '') {
      this.activeSort = null;
      // Reload data to get original order
      this.getAllUserList(true).then(() => {
        if (!this.isSearchActive) {
          this.updateDevList();
        }
      });
      return;
    }

    // Apply sorting to the full list

    // // Update paginated view (only if search is not active)
    // if (!this.isSearchActive) {
    //   this.paginateDevelopers();
    // }
  }


  private isLogoutHealthEntry(entry: any): boolean {
    if (!entry) return false;
    const state = (entry?.state || '').toUpperCase();
    if (state === 'LOGOUT' || state === 'LOGGED_OUT') return true;

    const rawReason = entry?.reasonCode || entry?.reason || '';
    if (!rawReason) return false;
    const rawCodes = rawReason.split(',').map((c: string) => c.trim()).filter(Boolean);
    if (rawCodes.length === 0) return false;

    return rawCodes.every((c: string) => {
      const upper = c.toUpperCase();
      return upper === 'ERR_USER_LOGGED_OUT' || upper === 'USER LOGGED OUT';
    });
  }

  /**
   * Get health value for sorting
   * Priority: unhealthy > starting > healthy > logout > uninstalled > unknown
   */
  private getHealthValueForSort(user: any): string {
    const history = user?.agentIntegrity?.healthHistory;
    if (Array.isArray(history) && history.length > 0) {
      const latest = history[history.length - 1];
      if (this.isLogoutHealthEntry(latest)) return '4-logout';
      const state = (latest?.state || '').toUpperCase();
      if (state === 'UNHEALTHY') return '1-unhealthy';
      if (state === 'STARTING') return '2-starting';
      if (state === 'HEALTHY') return '3-healthy';
      if (state === 'LOGOUT' || state === 'LOGGED_OUT') return '4-logout';
      if (state === 'UNINSTALLED') return '5-uninstalled';
    }
    if (user?.uninstall?.isUninstalled) return '5-uninstalled';
    return '6-unknown';
  }

  private getStatusValueForSort(user: any): string {
    const statusType = getEmployeeListStatusType(user, (status) =>
      this._sharedService.getDayDifferenceForAbsent(status)
    );
    switch (statusType) {
      case 'absent':
        return '1-absent';
      case 'auto-logout':
        return '2-auto-logout';
      case 'idle':
        return '3-idle';
      case 'invited':
        return '4-invite';
      case 'offline':
        return '5-offline';
      case 'online':
        return '6-online';
      default:
        return '4-invite';
    }
  }

  /**
   * Get app info value for sorting (version + application type)
   */
  private getAppInfoValueForSort(user: any): string {
    if (!user.appInfo) {
      return '';
    }
    const version = user.appInfo.version || '';
    const appType = user.appInfo.applicationType || '';
    return `${version} ${appType}`.trim();
  }

  openCreateTeamModal(iscreate, tid) {
    this.isTeamCreate = iscreate;
    this.teamSelectedId = tid;
    $("#CreateTeam").show();
  }

  closeCreateTeamModal() {
    $("#CreateTeam").hide();
  }

  openEmpModal(eId) {
    this._projectService.getEmployeeData(eId).subscribe((data: any) => {
      this.empName = data.name;
      this.empSlug = data.slug;
      $("#detailModal").show();
    });
    // $("#basicExampleModal").modal('show');
  }

  closeEmpModal() {
    $("#detailModal").hide();
  }

  openeditEmployeemodal(eid) {
    this.employeeId = eid;
    $("#EditEmployee").show();
  }

  EditEmployee() {
    this.loading = true;
    if (!this.createUserForm.valid) {
      return;
    }
    this._projectService
      .editEmployee(this.employeeId, this.createUserForm.value)
      .subscribe((data) => {
        $("#EditEmployee").hide();
        this.pageSize = this.EmpPaginator["_pageSize"];
        this.page = this.EmpPaginator["_pageIndex"] + 1;
        // this.getDevList();

        this.getAllUserList(true).then(() => {
          // Only update dev list if search is not active
          if (!this.isSearchActive) {
            this.updateDevList();
          }
        });

      });
  }

  closeEditEmployeemodal() {
    $("#EditEmployee").hide();
  }

  getUSer() {
    if (this.isTourActive()) {
      let roleArr = [];
      this._projectService.getUser().subscribe((data: any) => {
        this.tokenEncryptionService.setEncryptedItem('user', data);
        let isExpired = this._sharedService.checkPlanExpired(data)
        this.expired = isExpired;
        // if (isExpired) {
        //   return this._router.navigateByUrl('/plan-expired');
        // }
        roleArr = data.role;
        let quotaStatus = data.meta.quota_status;
        this.quota_remaining = data.meta.quota_remaining;
        this.quota_remaining = this.quota_remaining <= 0 ? 0 : this.quota_remaining;
        this.quotaStatus = quotaStatus;
        // if (data.meta.quota_remaining != 'false' && data.meta.quota_remaining != false) {
        if (quotaStatus == 'active' || quotaStatus == 'Active') {
          if (this.expiringDate(data.meta.expires_at, data.meta.today_date) <= data.meta.adv_pay) {
            this.isTrialBanner = false;
            this.isExpiredBanner = true;
          }
        }
        // }
        if (quotaStatus == 'trial' || quotaStatus == 'Trial') {
          this.isTrialBanner = false;
          this.isExpiredBanner = true;
        }
        if (quotaStatus == 'trial-expired' || quotaStatus == 'Trial-expired' || quotaStatus == 'expired' || quotaStatus == 'Expired') {
          this.isTrialBanner = true;
          this.isExpiredBanner = false;
          this.isQuota = true;
        }
        if (sessionStorage.getItem('isTrialBanner')) {
          this.isTrialBanner = true;
          this.isExpiredBanner = true;
        }

        this.totalUser = data.meta.quota_allowed;
        this.availableUser = data.meta.quota_remaining == 'false' || data.meta.quota_remaining == false ? 0 : data.meta.quota_remaining;
        this.availableUser = this.availableUser < 0 ? 0 : this.availableUser;
        if (data.meta.expires_at) {
          this.getRemainingDate(data.meta.expires_at)
        }

        let adminRole = roleArr.filter((ele) => {
          return (ele.toLowerCase().includes("admin") || ele.toLowerCase().includes("company"));
        })
        if (adminRole.length == 0) {
          this.isAdmin = false;
        } else {
          this.isAdmin = true;
        }
        this.canManageEmployees = canManageCompanyEmployees(data);
      })
    } else {
      let roleArr = [];
      this._projectService.getUser().subscribe((data: any) => {
        this.tokenEncryptionService.setEncryptedItem('user', data);
        let isExpired = this._sharedService.checkPlanExpired(data)
        this.expired = isExpired;
        // if (isExpired) {
        //   return this._router.navigateByUrl('/plan-expired');
        // }
        roleArr = data.role;
        let adminRole = roleArr.filter((ele) => {
          return (ele.toLowerCase().includes("admin") || ele.toLowerCase().includes("company"));
        })
        if (adminRole.length == 0) {
          this.isAdmin = false;
        } else {
          this.isAdmin = true;
        }
        this.canManageEmployees = canManageCompanyEmployees(data);
      })
    }
  }

  getTeamsData(): Promise<any> {
    return new Promise((res, rej) => {
      this._projectService.getTeamList().subscribe((resTeams) => {
        if (resTeams) {
          res(resTeams);
        } else {
          res([]);
        }
      }, (error) => {
        console.log("Checking error while getting teams data", error);
      })
    })
  }

  // expiringDate(strDate) {
  //   const expirationDate = new Date(strDate);
  //   const timeDifference = expirationDate.getTime() - new Date().getTime();
  //   const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
  //   let isExpirationNear = daysDifference < 15;
  //   // this.daysRemaining = Math.round(daysDifference);

  //   return isExpirationNear;
  // }

  expiringDate(strExpiredDate, strTodayDate) {
    const expirationDate = new Date(strExpiredDate);
    const timeDifference = expirationDate.getTime() - new Date(strTodayDate).getTime();
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    return daysDifference + 1;
  }

  getRemainingDate(strDate) {
    const expirationDate = new Date(strDate);
    const timeDifference = expirationDate.getTime() - new Date().getTime();
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    this.daysRemaining = Math.round(daysDifference);
  }

  getDeveloperList(params) {
    this._loginService.getUserList(params).subscribe(
      (users: any) => {

        users.developers.forEach((developer: any) => {
          developer["screenShotTime"] = developer.screenshot
            ? this.imageNameAndDate(developer.screenshot, "date")
            : null;
        });

        users.developers.sort((a, b) => a.screenShotTime - b.screenShotTime);
        this.allUsers = users.developers;
        this.developerList = JSON.parse(JSON.stringify(this.allUsers));
        this.developerList.forEach((user, index) => {
          if (user.userRole == "admin") {
            this.developerList.splice(index, 1);
          }
        });
        this.filteredList = this.developerList;
        this.loading = false;
        this.updateStatus(this.statusToUpdate);
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  getFirstName(name) {
    return name.split(" ")[0];
  }

  getLastName(name) {
    return name.split(" ")[1];
  }

  updateStatus(userToUpdate) {
    if (this.developerList) {
      _.forEach(userToUpdate, (id) => {

        let index = _.findIndex(this.developerList, function (o: any) {
          return o._id == id.user;
        });
        // console.log("index --------------->", this.developerList[index], index);
        if (index > -1 && id.status == "online") {
          this.developerList[index]["status"] = id.status;
        } else if (index > -1) {
          delete this.developerList[index]["status"];
        }
        this.filteredList = this.developerList;
      });
    }
  }

  editProject() {
    this._router.navigate(["/projects/add-project"], {
      queryParams: { groupId: this.groupId },
    });
  }

  checkTeamLead(dev) {
    // console.log("checkTeamLead", dev.name);
    return dev.teamLead.includes(this.groupId) ? true : false;
    // return true
  }

  getStatus(dev) {
    this._loginService.tickStatusChanged({
      userId: dev._id,
      status: dev.status,
    });
  }

  imageNameAndDate(image, type) {
    return this._sharedService.imageNameAndDate(image, type);
  }

  createTeam() {
    let formValue = this.createTeamForm.value;
    const team_managerArr: string[] = formValue.team_manager.split(",");
    let formatedTeam_manager: string = formValue.team_manager
      ? "~" + team_managerArr.join("~") + "~"
      : "";

    const team_leadArr: string[] = formValue.team_lead.split(",");
    let formatedTeam_lead: string = formValue.team_lead
      ? "~" + team_leadArr.join("~") + "~"
      : "";

    const team_developerArr: string[] = formValue.team_developer.split(",");
    let formatedTeam_developer: string = formValue.team_developer
      ? "~" + team_developerArr.join("~") + "~"
      : "";

    let teamData = {
      status: formValue.status,
      title: formValue.title,
      slug: formValue.slug,
      meta: {
        team_manager: formatedTeam_manager,
        team_lead: formatedTeam_lead,
        team_developer: formatedTeam_developer,
      },
    };

    if (this.isTeamCreate == true) {
      this._projectService.createTeamMember(teamData).subscribe((data) => {
        $("#CreateTeam").hide();
      });
    } else {

    }
  }

  openTeamDetailModal(tId) {
    this._projectService.getTeamDetail(tId).subscribe((data: any) => {
      $("#TeamdetailModal").show();
      //this.getTeam();
      this.teamSlug = data.slug;
      this.teamStatus = data.status;
      this.teamTitle = data.title.rendered;
    });
  }

  closeTeamDetailModal() {
    $("#TeamdetailModal").hide();
  }

  removeKeysWithUndefinedValues(obj: any): any {
    const newObj: any = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value !== undefined && value !== "") {
          newObj[key] = value;
        }
      }
    }

    return newObj;
  }

  searchEmployee(val: any) {
    this.isViewMore = false;
    this.searchedValue = val;

    // Persist search in URL without affecting other params
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: { 'search-employee': val || null, 'page': null },
      queryParamsHandling: 'merge'
    });

    if (val === "") {
      this.isSearchActive = false;
      this.getAllUserList(true).then(() => {
        // Apply sorting if active, then paginate
        if (this.activeSort && this.activeSort.active && this.activeSort.direction) {
          this.applySorting();
        }
        this.updateDevList();
        this.isViewMore = true;
      });
      return;
    }

    // Set search active flag
    this.isSearchActive = true;
    // Filter the main list first
    let isSelectedStatusFilters = this.selectedStatusFilters.length > 0 && !this.selectedStatusFilters.includes('all') ? false : true;
    const svalue = val.toUpperCase();
    let filtered;
    if (isSelectedStatusFilters) {
      filtered = this.allUserList.filter((ele) => {
        return ele.name.toUpperCase().includes(svalue);
      });
    } else {
      filtered = this.developerList.filter((ele) => {
        return ele.name.toUpperCase().includes(svalue);
      });
    }

    // Create a copy to sort (don't modify allUserList)
    let dataToSort = [...filtered];

    // Apply sorting to filtered results if active
    dataToSort = this.matSortReusable(dataToSort);

    this.developerList = dataToSort.slice(0, this.pageSize);
    this.filteredList = this.developerList;

    // Note: This simplified search does not currently support pagination of search results beyond the first page.
    // For full search result pagination, totalUsers would need to be updated based on filtered.length, and onPaginateChange would need to handle it.
    if (this.filteredList.length <= this.pageSize) {
      this.handleTablePaginationChanges(true);
    } else {
      this.handleTablePaginationChanges(false);
    }
  }

  btnViewMoreAction() {
    this.page = this.page + 1;
    this.getDevList();
  }

  onPaginateChange(event) {
    this.pageSize = this.EmpPaginator["_pageSize"];
    // Save pageSize to localStorage
    localStorage.setItem('pageSize', this.pageSize.toString());
    this.page = this.EmpPaginator["_pageIndex"] + 1;

    // Persist current page in URL
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: { 'page': this.page > 1 ? this.page : null },
      queryParamsHandling: 'merge'
    });

    // If search is active, don't call updateDevList as it will overwrite search results
    if (!this.isSearchActive) {
      this.updateDevList();
    }

    if (this.activeSort) {
      this.applySorting();
    }

    //this.currentPage = event.pageIndex;
  }

  trialCloseBanner() {
    sessionStorage.setItem('isTrialBanner', 'false');
    this.isTrialBanner = true;
    this.isExpiredBanner = true;
  }

  checkLogoutReason(logoutTime: string, lastActiveTime: string) {
    return moment(logoutTime).isSameOrAfter(moment(lastActiveTime));
  }

  refreshEmployeeList() {
    if (this.isRefreshing) {
      return; // Prevent multiple refreshes
    }
    this.isRefreshing = true;

    const previousSearch = this.searchedValue;
    const wasSearchActive = this.isSearchActive;
    const previousStatusFilters = [...(this.selectedStatusFilters || [])];

    this.getAllUserList(true).then(() => { // Pass true for forceRefresh
      if (previousStatusFilters.length > 0 && !previousStatusFilters.includes('all')) {
        this.filterDataOnMultipleStatusChange(previousStatusFilters, true);
      }

      if (wasSearchActive && previousSearch && previousSearch.trim() !== '') {
        this.searchEmployee(previousSearch);
      } else {
        this.updateDevList();
      }
      this.isRefreshing = false;
    }).catch(() => {
      this.isRefreshing = false;
      console.error("Failed to refresh employee list");
    });
  }

  /**
   * Apply sorting to the full user list
   * This method sorts allUserList in-place based on activeSort
   */
  private applySorting(): void {
    let whichArrayShouldBeSorted = this.selectedStatusFilters.length > 0 && !this.selectedStatusFilters.includes('all') ? this.totalStatusFilteredUsers : this.allUserList;
    this.developerList = whichArrayShouldBeSorted;
    if (!this.developerList || !this.developerList.length || !this.activeSort || !this.activeSort.active || !this.activeSort.direction) {
      return;
    }

    // Remove any duplicates by ID before sorting (safety check)
    const uniqueMap = new Map<string, any>();
    this.developerList.forEach(user => {
      if (user && user.id) {
        if (!uniqueMap.has(user.id)) {
          uniqueMap.set(user.id, user);
        }
      }
    });

    // If duplicates were found, replace the array
    if (uniqueMap.size !== this.developerList.length) {
      this.developerList = Array.from(uniqueMap.values());
    }

    this.developerList = this.matSortReusable(this.developerList);

    let startIndex = (this.page - 1) * this.pageSize;
    let endIndex = startIndex + this.pageSize;
    this.developerList = this.developerList.slice(startIndex, endIndex);
  }

  setSubjects() {
    this.openInvitedFocusDialogSub = this._sharedService.openInvitedFocusDialog.subscribe((res) => {
      const isAlreadyOpen = this.dialog.openDialogs.some(dialogRef => dialogRef.componentInstance instanceof InviteFocusDialogComponent);
      if (isAlreadyOpen) {
        if (this.dialogRefForInviteModal) {
          this.dialogRefForInviteModal.componentInstance.updatePosition(res.top, res.left, res.width, res.height);
        }
        return; // Prevent opening a new dialog if one is already open
      }

      // Check if any other modals are currently open (like download modal)
      if (this.dialog.openDialogs.length > 0) {
        console.log('Other modals are open, delaying invite modal');
        return; // Don't open invite modal if other modals are open
      }

      // Check if we're still in suppression mode
      const suppressInviteModal = this.route.snapshot.queryParams['suppressInviteModal'];
      if (suppressInviteModal === 'true' || this.employeeHandoff.isActive() || this.activationJourney.shouldSuppressInviteFocusCoach()) {
        console.log('Still in suppression mode, not opening invite modal');
        return;
      }

      this.dialogRefForInviteModal = this.dialog.open(InviteFocusDialogComponent, {
        panelClass: 'transparent-dialog',
        backdropClass: 'transparent-backdrop',
        disableClose: false,
        data: {
          top: res.top,
          left: res.left,
          width: res.width,
          height: res.height
        }
      });

      this.dialogRefForInviteModal.afterClosed().subscribe((response) => {
        this._sharedService.unobserveInviteBadge.next(true);
      })
    })

    this.setTimerFocusDialog = this._sharedService.setTimerFocusDialog.subscribe((res) => {
      if (res) {
        // Check if we should suppress the invite modal (coming from automatic employee creation)
        const suppressInviteModal = this.route.snapshot.queryParams['suppressInviteModal'];
        if (suppressInviteModal === 'true' || this.employeeHandoff.isActive() || this.activationJourney.shouldSuppressInviteFocusCoach()) {
          // Don't set the timer if we're suppressing the invite modal initially
          console.log('Suppressing invite modal timer due to suppressInviteModal parameter');
          return;
        }

        if (this.timerSubDialog) {
          this.timerSubDialog.unsubscribe();
        }
        this.timerSubDialog = timer(this.totalDuration).subscribe(() => {
          this.usersTableComp.checkIsOpenInvitedModal();
        });
      }
    })
  }

  listenStatusFilterChange(statuses: any) {
    const newFilterValues = statuses.map((status) => status.value);

    // Check if the filter selection has actually changed
    const currentSorted = [...(this.selectedStatusFilters || [])].sort().join('_');
    const newSorted = [...newFilterValues].sort().join('_');
    const isFilterChanged = currentSorted !== newSorted;

    this.selectedStatusFilters = newFilterValues;

    const nextFilterParam = this.selectedStatusFilters.length > 0
      ? this.selectedStatusFilters.join('_')
      : null;
    const currentFilterParam = this.route.snapshot.queryParamMap.get('filter');

    // Skip navigate when URL already matches — prevents queryParams ↔ emit loops
    if (currentFilterParam !== nextFilterParam) {
      this._router.navigate([], {
        relativeTo: this.route,
        queryParams: { filter: nextFilterParam },
        queryParamsHandling: 'merge',
        replaceUrl: !this.isFilterInitialized
      });
    }

    if (isFilterChanged && this.isFilterInitialized) {
      this.resetMatPagination(false);
      this.filterDataOnMultipleStatusChange(this.selectedStatusFilters, true);
    } else {
      this.filterDataOnMultipleStatusChange(this.selectedStatusFilters, false);
    }
    this.isFilterInitialized = true;
  }

  /**
   * Re-applies the current filter to ensure proper filtering after data load
   * This is called after data is fetched to handle cases where filter was emitted before data was loaded
   */
  private reapplyCurrentFilter() {
    if (this.selectedStatusFilters && this.selectedStatusFilters.length > 0) {
      // Trigger change detection to apply the filter with newly loaded data
      this._cd.markForCheck();
      this._cd.detectChanges();
    }
  }

  filterDataOnMultipleStatusChange(statuses: string[], isStartFromZeroIndex?: boolean) {
    if (this.expired) return 'none';
    let startIndex;
    let endIndex;
    if (isStartFromZeroIndex) {
      startIndex = 0;
      endIndex = startIndex + this.pageSize;
    } else {
      startIndex = (this.page - 1) * this.pageSize;
      endIndex = startIndex + this.pageSize;
    }
    if (!statuses || statuses.length === 0) {
      // Create a fresh slice to avoid duplicates
      let ifFilterBySearch = this.filterOnUserName(this.allUserList);
      this.developerList = ifFilterBySearch.slice(startIndex, endIndex);
      this.checkPageSize(this.allUserList)
      return;
    }

    if (statuses.length == 1 && statuses[0] == "all") {
      let ifFilterBySearch = this.filterOnUserName(this.allUserList);
      this.developerList = ifFilterBySearch.slice(startIndex, endIndex);
      this.checkPageSize(this.allUserList)
      return;
    }

    const combinedFilteredList = filterEmployeesBySelectedStatuses(
      this.allUserList,
      statuses,
      (status) => this._sharedService.getDayDifferenceForAbsent(status)
    );

    let filterUserBySearch = this.filterOnUserName(combinedFilteredList);

    const absentOnly = statuses.length === 1 && statuses[0] === 'absent';
    const userChoseOtherColumn = !!(
      this.activeSort?.active &&
      this.activeSort.active !== 'status' &&
      this.activeSort.active !== 'lastSeen'
    );
    if (absentOnly && !userChoseOtherColumn) {
      this.activeSort = { active: 'lastSeen', direction: 'asc' };
    }
    filterUserBySearch = this.matSortReusable([...(filterUserBySearch || [])]);

    this.totalStatusFilteredUsers = filterUserBySearch;
    this.developerList = filterUserBySearch?.slice(startIndex, endIndex);
    this.checkPageSize(filterUserBySearch)
  }

  checkPageSize(list) {
    if (list.length <= this.pageSize) {
      this.handleTablePaginationChanges(true);
    } else {
      this.handleTablePaginationChanges(false);
    }
  }

  refreshItemsOnStatusChange() {
    if (this.allUserList && this.selectedStatusFilters) {
      this.filterDataOnMultipleStatusChange(this.selectedStatusFilters);
    }
  }

  matSortReusable(dataToSort: any) {
    // Apply sorting to filtered results if active
    if (this.activeSort && this.activeSort.active && this.activeSort.direction) {
      const isAsc = this.activeSort.direction === "asc";

      dataToSort.sort((a, b) => {
        let valueA: any;
        let valueB: any;

        switch (this.activeSort.active) {
          case "Employee Name":
            valueA = (a.name || '').toLowerCase();
            valueB = (b.name || '').toLowerCase();
            break;
          case "role":
            valueA = a.role && a.role.length > 1 ? a.role[1] : (a.role && a.role.length > 0 ? a.role[0] : '');
            valueB = b.role && b.role.length > 1 ? b.role[1] : (b.role && b.role.length > 0 ? b.role[0] : '');
            valueA = (valueA || '').toLowerCase();
            valueB = (valueB || '').toLowerCase();
            break;
          case "status":
            valueA = this.getStatusValueForSort(a);
            valueB = this.getStatusValueForSort(b);
            break;
          case "lastSeen": {
            const seen = compareLastSeenOldestFirst(getLastSeenMs(a), getLastSeenMs(b));
            return isAsc ? seen : -seen;
          }
          case "health":
            valueA = this.getHealthValueForSort(a);
            valueB = this.getHealthValueForSort(b);
            break;
          case "screenshot":
            valueA = a.meta?.last_screenshot ? new Date(a.meta.last_screenshot).getTime() : 0;
            valueB = b.meta?.last_screenshot ? new Date(b.meta.last_screenshot).getTime() : 0;
            return isAsc ? valueB - valueA : valueA - valueB;
          case "usedApps":
            valueA = (a.meta?.last_application_name || '').toLowerCase();
            valueB = (b.meta?.last_application_name || '').toLowerCase();
            break;
          case "appInfo":
            valueA = this.getAppInfoValueForSort(a).toLowerCase();
            valueB = this.getAppInfoValueForSort(b).toLowerCase();
            break;
          default:
            return 0;
        }

        if (valueA < valueB) return isAsc ? -1 : 1;
        if (valueA > valueB) return isAsc ? 1 : -1;
        return 0;
      });
    }

    return dataToSort;
  }

  handleTablePaginationChanges(flag: boolean) {
    this.disableNextFlag = flag;
    // if (flag) {
    //   this.pageSizeOption = [25];
    // } else {
    //   this.pageSizeOption = [25, 50, 100];
    // }
  }

  get paginatorLength(): number {
    if (this.disableNextFlag) {
      return this.developerList.length; // only 1 page
    } else if (!this.disableNextFlag && this.selectedStatusFilters?.length > 0 && !this.selectedStatusFilters?.includes('all') && this.developerList?.length < this.totalStatusFilteredUsers?.length) {
      return this.totalStatusFilteredUsers?.length;
    } else {
      return this.totalUsers;
    }
  }

  resetMatPagination(resetPageSize: boolean = true): void {
    const newPageSize = resetPageSize ? 25 : this.pageSize;
    this.page = 1;
    this.pageSize = newPageSize;
    if (resetPageSize) {
      localStorage.setItem('pageSize', this.pageSize.toString());
    }
    if (this.EmpPaginator) {
      this.EmpPaginator.pageSize = this.pageSize;
      this.EmpPaginator.firstPage();
    }
  }

  filterOnUserName(usersList: any) {
    // Return an array in every branch so callers can .slice() unconditionally
    // (fresh-signup race: filter can emit before the users fetch resolves).
    const safeList: any[] = Array.isArray(usersList) ? usersList : [];
    if (this.isSearchActive && this.searchedValue.trim() !== "") {
      const sValue = this.searchedValue.toUpperCase();
      return safeList.filter((ele: any) => {
        return (ele?.name || '').toUpperCase().includes(sValue);
      });
    }
    return safeList;
  }

}
